module.exports = __webpack_public_path__ + "static/media/yellowCircleIcon.1700061f.svg";